import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryOrder extends BaseModelAPI {
	static entity = 'deliveryorder';
	static entityName = 'deliveryorder';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.doNumber = '';
			this.doDate = '';
			this.deliveryOrderStatusId = '';
			this.deliveryOrderStatus = {};
			this.customerId = '';
			this.customer = {};
			this.remarks = '';
			this.deliveryOrderDetails = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}